<template>
	<div class="personal-wrapper">
		<div class="home-wrapper">
			<div>
				<el-image class="headUrl" :src="data.avatar" fit="fill">
					<div slot="error" class="image-slot">
					  <el-image class="headUrl" :src="require('@/assets/header.png')" fit="fill"></el-image>
					</div>
				</el-image>
			</div>
			<div class="usermsg">
				<div><span class="username">{{data.nickname}}</span><i class="iconfont" :class="{'icon-nanxing': data.sex == 1,'icon-female': data.sex == 2}"></i></div>
				<div>{{data.summary}}</div>
				<div v-if="data.companyName"><i class="iconfont icon-gongsi"></i>{{data.companyName}}</div>
				<div><i class="iconfont icon-gongwenbao-F"></i>{{data.profession}}</div>
			</div>
			<div class="right-item">
				<div>
					<div class="num">{{data.topicCount}}</div>
					<div class="title">发布话题</div>
				</div>
				<hr />
				<div>
					<div class="num">{{data.collectedCount}}</div>
					<div class="title">被收藏</div>
				</div>
				<hr />
				<div>
					<div class="num">{{data.likedCount}}</div>
					<div class="title">被赞</div>
				</div>
				<div class="edit-btn">
					<el-button type="warning" size="medium" @click="$router.push({path:'/personal/profile'})">编辑</el-button>
				</div>
			</div>
		</div>
		<div class="route-wrapper">
			<el-tabs class="tab-container" v-model="activeName" @tab-click="handleClick">
			    <el-tab-pane v-for="item in typeList" :label="item.title" :name="item.id">
					
				</el-tab-pane>
			</el-tabs>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import { getSelfInfo, getCommentList } from '@/api/personal/user'
export default {
    data() {
      return {
		activeName: '0',
		typeList:[
			{
				id:'0',
				title: '我的话题',
				url:'/personal/homepage/topic'
			},
			{
				id:'1',
				title: '我的收藏',
				url:'/personal/homepage/collection'
			},
			{
				id:'2',
				title: '我的草稿',
				url:'/personal/homepage/draft'
			},
			{
				id:'3',
				title: '我的评论',
				url:'/personal/homepage/comment'
			},
			{
				id:'4',
				title: '我的关注',
				url:'/personal/homepage/attention'
			},
			{
				id:'5',
				title: '历史记录',
				url:'/personal/homepage/history'
			},
			
		],
		data:{
			gender: '女',
			name: 'wq'
		}
      };
    },
    methods: {
	  handleClick(tab, event) {
		if(tab.name == '0'){
			this.$router.push({path:'/personal/homepage/topic'})
		}else if(tab.name == '1'){
			this.$router.push({path:'/personal/homepage/collection'})
		}else if(tab.name == '2'){
			this.$router.push({path:'/personal/homepage/draft'})
		}else if(tab.name == '3'){
			this.$router.push({path:'/personal/homepage/comment'})
		}else if(tab.name == '4'){
			this.$router.push({path:'/personal/homepage/attention'})
		}else if(tab.name == '5'){
			this.$router.push({path:'/personal/homepage/history'})
		}
		this.activeName = tab.name;
	  },
      async getInfo(){
      	const res = await getSelfInfo()
      	if (res.code === 0) {
      		this.data = res.data
      	} else {
      	  this.$message.error(res.msg)
      	}
      },
    },
	mounted(){
		this.getInfo()
		this.$nextTick(()=>{
		  this.typeList.forEach((item)=>{
		    if(this.$route.path.indexOf(item.url) !== -1){
		      this.activeName = item.id
		    }
		  })
		})
	}
  }
</script>

<style lang="scss" scoped>
.personal-wrapper{
	max-width: 1400px;
	width: 80vw;
	margin: 80px auto;
	padding-top: 20px;
	.home-wrapper{
		background: #fff;
		border-radius: 10px;
		padding: 30px;
		&>div{
			display: inline-block;
			vertical-align: top;
			color: #949494;
			margin-right: 20px;
			.headUrl{
				width: 60px;
				height: 60px;
				border-radius: 50%;
			}
			&.usermsg{
				width: calc(100% - 320px);
				&>div{
					margin-bottom: 10px;
					font-size: 16px;
					.username{
						font-size: 24px;
						color: #313131;
						// font-weight: 800;
					}
					.icon-nanxing{
						color: #64A6FF;
						margin-left: 10px;
						font-size: 20px;
						vertical-align: middle;
					}
					.icon-female{
						color: #FF64C4;
						margin-left: 10px;
						font-size: 20px;
						vertical-align: middle;
					}
					.iconfont{
						margin-right: 10px;
					}
				}
			}
			&.right-item{
				width: 220px;
				margin-right: 0;
				&>div{
					display: inline-block;
					text-align: center;
					margin: 0 15px;
					.num{
						font-size: 22px;
						font-weight: 800;
						margin-bottom: 5px;
						color: #525254;
					}
					.title{
						font-size: 14px;
						color: #ADADAD;
					}
					&.edit-btn{
						display: block;
						text-align: right;
						margin-top: 40px;
						.el-button--warning{
							background-color: #FF842E;
							width: 100px;
						}
					}
				}
				hr{
					height: 20px;
					border: 1px solid #EBEAEA;
					display: inline-block;
				}
			}
			
		}
	}
	.route-wrapper{
		background: #fff;
		border-radius: 10px;
		margin-top: 20px;
		padding: 20px 30px;
		.tab-container{
			/deep/.el-tabs__nav-wrap::after{
				height: 1px;
			}
			/deep/.el-tabs__active-bar{
				width: 25px !important;
				margin-left: 25px;
				background-color: #FF842E;
			}
			/deep/.el-tabs__item{
				font-size: 18px;
				font-weight: 800px;
				&.is-active{
					color: #FF842E;
				}
				&:hover{
					color: #FF842E;
				}
			}
		}
	}
}
</style>